export const REGULAR_PAGE_FLOW_MAX_WIDTH = '1400px';
